import { Component, ViewChild } from '@angular/core';
import { DialogService } from 'src/app/layout/services/dialog.service';
import { HttpClient } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { EditFunctiiComponent } from './edit-functii/edit-functii.component';
import { UpdateFunctii } from './functii.interface';
import Swal from 'sweetalert2';
import { FunctiiService } from './functii.service';
import { DataTablesResponse } from 'src/app/interfaces/data-table-response.interface';
import { AddFunctiiComponent } from './add-functii/add-functii.component';

@Component({
  selector: 'app-functii',
  templateUrl: './functii.component.html',
  styleUrls: ['./functii.component.scss'],
})
export class FunctiiComponent {
  @ViewChild(DataTableDirective, { static: false })
  dtElement!: DataTableDirective;

  isLoading = false;
  selectedSection: string = '';

  dtOptions: any = {};
  dtTrigger: Subject<any> = new Subject<any>();

  dtLink =
    environment.interop.basePath +
    environment.interop.urbanism.nomenclatoare.functie.getFunctiiDT;

  dataTablesParameters: any = {
    data: {
      key: 'parameter',
    },
  };
  constructor(
    private dialogService: DialogService,
    private http: HttpClient,
    private dialog: MatDialog,
    private functiiService: FunctiiService
  ) {}

  ngOnInit(): void {
    this.renderDT();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next('');
  }

  renderDT() {
    this.isLoading = true;
    this.dtOptions = {
      serverSide: true,
      responsive: true,
      pageLength: 25,

      ajax: (dataTablesParameters: any, callback: any) => {
        this.isLoading = true;

        this.http
          .post<DataTablesResponse>(this.dtLink, dataTablesParameters)
          .subscribe((resp: any) => {
            this.isLoading = false;
            callback({
              recordsTotal: resp.data.recordsTotal,
              recordsFiltered: resp.data.recordsFiltered,
              data: resp.data.data,
            });
          });
      },
      language: environment.config.romanianLanguageDataTable,
      columns: [
        {
          title: 'ID',
          data: 'id',
        },
        {
          title: 'Nume',
          data: 'name',
        },
        {
          title: 'Acțiuni',
          data: null,
          orderable: false,
          className: 'all',
          render: () => {
            return `
              <button class="action-btn edit">
                <img class="btn-img" src="../../../../assets/icons/edit.svg" alt="edit"/>
              </button>
              <button class="action-btn delete">
                <img class="btn-img" src="../../../../assets/icons/delete.svg" alt="delete"/>
              </button>
            `;
          },
        },
      ],
      rowCallback: (row: Node, data: any[] | any) => {
        const lastTd = (row as HTMLElement).querySelector('td:last-child');
        const editIcon = lastTd?.querySelector('.edit');
        const deleteIcon = lastTd?.querySelector('.delete');

        if (editIcon) {
          editIcon.addEventListener('click', () => {
            this.openEditDialog(data);
          });
        }

        if (deleteIcon) {
          deleteIcon.addEventListener('click', () => {
            const { id } = data;
            this.deleteFunctii(id);
          });
        }

        return row;
      },
    };
  }

  rerenderDT(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next('');
    });
  }

  openAddDialog() {
    const dialogRef = this.dialog.open(AddFunctiiComponent, {
      ...this.dialogService.getDialogConfig(),
    });
    dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
      if (success) {
        this.rerenderDT();
      }
    });
  }

  openEditDialog(data: UpdateFunctii) {
    const dialogRef = this.dialog.open(EditFunctiiComponent, {
      ...this.dialogService.getDialogConfig(),
      data,
    });

    dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
      if (success) {
        this.rerenderDT();
      }
    });
  }

  deleteFunctii(functiiId: number) {
    Swal.fire({
      title: 'Sunteți sigur?',
      text: 'Nu o să puteți recupera datele odată cu ștergerea lor!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#DD6B55',
      confirmButtonText: 'Confirm!',
      cancelButtonText: 'Anulare',
      showLoaderOnConfirm: true,
    }).then((result) => {
      if (result.isConfirmed) {
        this.functiiService.deleteFunctiiData(functiiId).subscribe(() => {
          this.rerenderDT();
          Swal.fire({
            title: 'Șters!',
            text: 'Funcție ștearsă cu succes.',
            icon: 'success',
            confirmButtonText: 'OK',
          });
        });
      }
    });
  }
}
